export default __webpack_public_path__ + "static/media/digitrust.662f6fa9.svg";